import { render } from "./BaseEllipsis.vue?vue&type=template&id=4d56fd93"
import script from "./BaseEllipsis.vue?vue&type=script&lang=js"
export * from "./BaseEllipsis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__